import styled from '@emotion/styled';

export const TooltipContainer = styled.div`
  border-radius: 15px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.midDarkGrey};
  padding: 10px 20px;
`;
